import React from 'react';
import MaterialInput from '@material-ui/core/Input';
import classnames from 'classnames';
import styles from './Input.scss';

const Input = React.forwardRef(({ className, ...props }, ref) =>
    <MaterialInput
        inputRef={ref}
        className={classnames(styles.base, className)}
        { ...props }
    />);

export default Input;
